import React from 'react';
import { Link } from '@chakra-ui/react';
import ToggableBanner from 'features/ToggableBanner/toggable-banner';

export default function IsInGracePeriodBanner({ meData }) {
  const isInGracePeriod = meData?.subscription?.isInGracePeriod;
  if (!isInGracePeriod) return null;

  const cancelDateObject = new Date(meData?.subscription?.currentPeriodEnd * 1000);
  const daysOfGraceForMe = meData?.subscription?.gracePeriodDays;

  cancelDateObject.setDate(cancelDateObject.getDate() + daysOfGraceForMe);
  const formatedDate = cancelDateObject.toLocaleDateString('en-us', {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
  });

  return (
    <ToggableBanner showBanner={isInGracePeriod}>
      <Link href="/settings#membership">
        {`Your subscription has expired and your music will be taken down on ${formatedDate}. Please update your payment method in settings to continue using the Venice platform.`}
      </Link>
    </ToggableBanner>
  );
}
